import gql from "graphql-tag";

export const VIEW_MESSAGE = gql`
  subscription chat_messages(
    $sender_admin_user_id: uuid
    $business_user_id: uuid
  ) {
    chat_messages(
      where: {
        sender_admin_user_id: { _eq: $sender_admin_user_id }
        _and: {
          message_recipients: { reciever_user_id: { _eq: $business_user_id } }
        }
      }
      order_by: { created_at: desc }
    ) {
      id
      message
      created_at
      updated_at
      admin_user {
        id
        full_name
        profile_photo_url
        profile_photo_path
      }
    }
  }
`;
